module.exports = __webpack_public_path__ + "img/czech-republic-logo-icon.8b933261.png";